import React from "react";

export default function MSAccess_Len() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Len</h1>
      <p>This is the MSAccess_Len component generated from the SQL JSON.</p>
    </div>
  );
}
